import React from "react";
import { Link } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { HERO_IMG } from "@/lib/constants";
import { useContent } from "@/context/ContentContext";

export default function About() {
  const c = useContent();
  const items = c.about?.items || [];
  return (
    <Layout>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-14 sm:py-20">
        <span className="font-mono text-xs tracking-[0.2em] uppercase text-[#8CE63C]">Who We Are</span>
        <h1 className="font-display text-4xl sm:text-5xl font-black text-white uppercase tracking-tight mt-4">{c.about?.heading || "About Us"}</h1>

        <div className="mt-8 rounded-2xl border border-[#232f25] bg-[#111712] overflow-hidden">
          <div className="aspect-[21/9] overflow-hidden bg-[#0d120e]">
            <img src={HERO_IMG} alt="Electric powersports" className="w-full h-full object-cover opacity-80" />
          </div>
          <div className="p-6 sm:p-10">
            <p className="text-lg sm:text-xl text-[#f4f7f4] leading-relaxed" data-testid="about-text">
              {c.about?.text}
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mt-8">
              {items.map((it) => (
                <div key={it} className="rounded-md border border-[#232f25] bg-[#0d120e] px-4 py-3 text-sm font-semibold text-[#9EABA0]">
                  <span className="text-[#8CE63C] mr-2">▸</span>{it}
                </div>
              ))}
            </div>
            <div className="mt-9 flex flex-col sm:flex-row gap-3">
              <Link to="/" className="px-6 py-3 rounded-md bg-[#8CE63C] text-[#080b08] text-sm font-bold uppercase tracking-wide hover:bg-[#9df04f] transition-colors text-center">
                View Products
              </Link>
              <Link to="/special-requests" className="px-6 py-3 rounded-md bg-[#0d120e] border border-[#232f25] text-sm font-semibold text-[#f4f7f4] hover:border-[#8CE63C]/50 transition-colors text-center">
                Request a Custom Unit
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
